import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

import { OrganizationUserContext } from "./Organization";
import { OutreachTemplatesContext } from "./OutreachTemplates";

export const enum EmailBrandPage {
  selectBrand = "selectBrand",
  emailBrand = "emailBrand",
  complete = "complete",
}

interface OnboardingDialogsContextInterface {
  profileDialogOpen: boolean;
  setProfileDialogOpen: Dispatch<SetStateAction<boolean>>;
  emailBrandDialogOpen: boolean;
  setEmailBrandDialogOpen: Dispatch<SetStateAction<boolean>>;
  createTemplateOnboardingDialogOpen: boolean;
  setCreateTemplateOnboardingDialogOpen: Dispatch<SetStateAction<boolean>>;
  emailBrandDialogPage: EmailBrandPage;
  setEmailBrandDialogPage: Dispatch<SetStateAction<EmailBrandPage>>;
  completeOnboardingDialogOpen: boolean;
  setCompleteOnboardingDialogOpen: Dispatch<SetStateAction<boolean>>;
  incompleteProfile: boolean;
  noTemplates: boolean;
}

const defaultContextMissingFunction = () => {
  throw new Error("context is missing");
};

const defaultInterface = {
  profileDialogOpen: false,
  setProfileDialogOpen: defaultContextMissingFunction,
  emailBrandDialogOpen: false,
  setEmailBrandDialogOpen: defaultContextMissingFunction,
  createTemplateOnboardingDialogOpen: false,
  setCreateTemplateOnboardingDialogOpen: defaultContextMissingFunction,
  emailBrandDialogPage: EmailBrandPage.selectBrand,
  setEmailBrandDialogPage: defaultContextMissingFunction,
  completeOnboardingDialogOpen: false,
  setCompleteOnboardingDialogOpen: defaultContextMissingFunction,
  incompleteProfile: false,
  noTemplates: false,
};

const OnboardingDialogsContext =
  createContext<OnboardingDialogsContextInterface>(defaultInterface);

interface OnboardingDialogsProviderProps {
  children: React.ReactElement;
}

const OnboardingDialogsProvider = ({
  children,
}: OnboardingDialogsProviderProps) => {
  const { templates } = useContext(OutreachTemplatesContext);
  const { profile, currentOrg } = useContext(OrganizationUserContext);
  const [profileDialogOpen, setProfileDialogOpen] = useState<boolean>(false);
  const [emailBrandDialogPage, setEmailBrandDialogPage] =
    useState<EmailBrandPage>(EmailBrandPage.selectBrand);
  const [emailBrandDialogOpen, setEmailBrandDialogOpen] =
    useState<boolean>(false);
  const [
    createTemplateOnboardingDialogOpen,
    setCreateTemplateOnboardingDialogOpen,
  ] = useState<boolean>(false);
  const [completeOnboardingDialogOpen, setCompleteOnboardingDialogOpen] =
    useState<boolean>(false);

  const noTemplates = templates.length === 0;

  const incompleteProfile =
    !profile?.wishlistBrands ||
    profile?.wishlistBrands?.length === 0 ||
    currentOrg?.bentoCategories?.length === 0;

  return (
    <OnboardingDialogsContext.Provider
      value={{
        profileDialogOpen,
        setProfileDialogOpen,
        emailBrandDialogOpen,
        setEmailBrandDialogOpen,
        createTemplateOnboardingDialogOpen,
        setCreateTemplateOnboardingDialogOpen,
        emailBrandDialogPage,
        setEmailBrandDialogPage,
        completeOnboardingDialogOpen,
        setCompleteOnboardingDialogOpen,
        incompleteProfile,
        noTemplates,
      }}
    >
      {children}
    </OnboardingDialogsContext.Provider>
  );
};

export { OnboardingDialogsProvider, OnboardingDialogsContext };
